<template>
  <div class="bs-wrapper not-found-box">
    <empty image="network" description="无法找到页面" />
  </div>
</template>

<script>
import 'vant/lib/empty/style';

export default {
  name: 'NotFound',

  mixins: [],

  components: {
    Empty: () => import('vant/lib/empty'),
  },

  props: {},

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {},
};
</script>

<style lang="less" scoped></style>
